import { warnUnrenderableBlockType } from '@lib/warnUnrenderableBlockType';

export enum BlockContentContext {
  Article = 'article',
  ProductArticle = 'productArticle',
  Stripped = 'stripped',
}

const PORTABLE_TEXT_PRIMITIVES = ['block', 'span'];

/** Declared here rather than imported: `@portabletext/types` is only a transitive dependency. */
export interface PortableTextBlock {
  _type: string;
  [key: string]: unknown;
}

/** Load-bearing: Portable Text throws on a `_type` with no serializer, so unknowns go here. */
export const selectRenderableBlocks = (
  value: PortableTextBlock[] | undefined,
  serializerTypes: Iterable<string>,
): PortableTextBlock[] | undefined => {
  const renderable = new Set([...serializerTypes, ...PORTABLE_TEXT_PRIMITIVES]);

  return value?.filter((component) => {
    const { _type: type } = component ?? {};
    if (typeof type === 'undefined') return false;
    if (renderable.has(type)) return true;

    warnUnrenderableBlockType(
      'BlockContent',
      type,
      'Register a serializer for it in block-content/types/index.ts (then re-run ' +
        '`pnpm gen:sanity-map`). Until then the block is filtered out of the rich-text body.',
    );
    return false;
  });
};
